import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const MILLSECTORTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.MillSectorType.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
];

export const MILLSECTORTYPE_CONFIG = {
  entityName: 'MillSectorType',
  localizationKey: 'Planning::Entity.MillSectorType',
  fields: MILLSECTORTYPE_FIELDS,
  permission: 'ControllingStructural.MillSectorTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Structural + MENU_NAME_SUFFIX,
};
